var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-mode-switcher"},[_c('r-radio-group',{attrs:{"button-list":_vm.modes,"active":_vm.mode},on:{"change":_vm.changeMode}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }